import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const enlish = {
  nameTitle: 'Profile name',
  namePlaceholder: 'Please enter your full name',
  imageTitle: 'Profile picture',
  imageSubtitle: 'Please upload your profile picture',
  emailTitle: 'Email',
  emailPlaceholder: 'Please enter your email',
  nameUpdateFailed: 'Failed to update name',
  profilePictureUpdateFailed: 'Failed to update profile picture',
  profileDataUpdateSuccessful: 'Successfully updated profile data',
  profileSettingsTitle: 'Profile info',
  profileSettingsSubtitle:
    'Update your name and profile photo here to keep your account information current',
  saveChanges: 'Save changes',
  language: 'language',
};

const welsh = {
  nameTitle: 'Enw proffil',
  namePlaceholder: 'Rhowch eich enw llawn',
  imageTitle: 'Llun proffil',
  imageSubtitle: 'Rhowch eich llun proffil',
  emailTitle: 'e-bost',
  emailPlaceholder: 'Rhowch eich e-bost',
  nameUpdateFailed: "Methwyd â diweddaru'r enw",
  profilePictureUpdateFailed: "Methwyd â diweddaru'r llun proffil",
  profileDataUpdateSuccessful: "Data proffil wedi'i ddiweddaru'n llwyddiannus",
  profileSettingsTitle: 'Gwybodaeth proffil',
  profileSettingsSubtitle:
    "Diweddarwch eich enw a'ch llun proffil yma i gadw'ch gwybodaeth gyfrif yn gyfredol.",
  saveChanges: 'Cadw newidiadau',
  language: 'Iaith',
};

export const userProfileText: any = getLocalizationBasedOnLang(enlish, welsh);
